import { Model } from '@vuex-orm/core';
import STORE from '@/store/STORE';

const { name } = STORE.modules.recipeModule;

export default class RecipeModule extends Model {
  static entity = `${name}`;

  static primaryKey = 'trial_id';

  static fields() {
    return {
      trial_id: this.attr(null),
      processes: this.attr({}),
      recipes: this.attr({}),
    };
  }

  static methodConf = {
    http: {
      url: '/modules/recipe',
    },
    methods: {
      $get: {
        name: 'get',
        http: {
          url: '/:id/object',
          method: 'get',
        },
      },
      $create: {
        name: 'create',
        http: {
          url: '/:id/object',
          method: 'put',
        },
      },
    },
  };
}
